import {
    apiCguCreatePerfil,
    apiCguCreatePermiso,
    apiCguGetPerfiles,
    apiCguGetPermisoPerfil,
} from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormPerfil, getModelPerfil } from "../models/PerfilModel";

import { EnumPerfilesPrincipales } from "../settings/enumConfig";
import { fnHandleChangeText } from "../settings/handleConfig";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const PerfilContext = createContext();

export function PerfilProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();

    const [listaPerfiles, setListaPerfiles] = useState([]);
    const [listaSistemaModulos, setListaSistemaModulos] = useState([]);
    const [listaSistemaSubmodulos, setListaSistemaSubmodulos] = useState([]);
    const [listaSistemaBotones, setListaSistemaBotones] = useState([]);
    const [listaPermisosPerfil, setListaPermisosPerfil] = useState([]);
    const [perfilSeleccionado, setPerfilSeleccionado] = useState(getModelPerfil());
    const [modalOpenFormPerfil, setModalOpenFormPerfil] = useState(false);
    const [modalOpenEliminarPerfil, setModalOpenEliminarPerfil] = useState(false);
    const [modalOpenAdministrarPerfil, setModalOpenAdministrarPerfil] = useState(false);
    const [modalOpenSeleccionarModulos, setModalOpenSeleccionarModulos] = useState(false);
    const [modalOpenSeleccionarSubmodulos, setModalOpenSeleccionarSubmodulos] = useState(false);
    const [modalOpenSeleccionarBotones, setModalOpenSeleccionarBotones] = useState(false);
    const [modulosSeleccionados, setModulosSeleccionados] = useState([]);
    const [submodulosSeleccionados, setSubmodulosSeleccionados] = useState([]);
    const [botonesSeleccionados, setBotonesSeleccionados] = useState([]);
    const [seleccionarTodoModulos, setSeleccionarTodoModulos] = useState(false);
    const [seleccionarTodoSubmodulos, setSeleccionarTodoSubmodulos] = useState(false);
    const [seleccionarTodoBotones, setSeleccionarTodoBotones] = useState(false);
    const [formPerfil, setFormPerfil] = useState(getFormPerfil());

    const handleChangePerfilSeleccionado = (value) => {
        setPerfilSeleccionado(value);
    };

    const handleOpenFormPerfil = (value) => {
        setModalOpenFormPerfil(value);
    };

    const handleOpenEliminarPerfil = (value) => {
        setModalOpenEliminarPerfil(value);
    };

    const handleOpenAdministrarPerfil = (value) => {
        setModalOpenAdministrarPerfil(value);
    };

    const handleOpenSeleccionarModulos = (value) => {
        setModalOpenSeleccionarModulos(value);
    };

    const handleOpenSeleccionarSubmodulos = (value) => {
        setModalOpenSeleccionarSubmodulos(value);
    };

    const handleOpenSeleccionarBotones = (value) => {
        setModalOpenSeleccionarBotones(value);
    };

    const handleChangeFormText = fnHandleChangeText(formPerfil, setFormPerfil);

    const handleClickNuevoPerfil = () => {
        const perfil = getModelPerfil();
        fnFillFormPerfil(perfil);
        setPerfilSeleccionado(perfil);
        setModalOpenFormPerfil(true);
    };

    const handleClickEditarPerfil = () => {
        if (perfilSeleccionado.iIdPerfil === 0) {
            handleOpenAlert("Seleccione un perfil para editar");
            return;
        }
        fnFillFormPerfil(perfilSeleccionado);
        setModalOpenFormPerfil(true);
    };

    const handleClickEliminarPerfil = () => {
        if (perfilSeleccionado.iIdPerfil === 0) {
            handleOpenAlert("Seleccione un perfil para eliminar");
            return;
        }
        const perfilesNoEliminar = [
            EnumPerfilesPrincipales.Superadministrador,
            EnumPerfilesPrincipales.Administrador,
            EnumPerfilesPrincipales.DoctorCallCenter,
            EnumPerfilesPrincipales.DoctorEspecialista,
            EnumPerfilesPrincipales.AdministradorEspecialiesta,
        ];
        if (perfilesNoEliminar.includes(perfilSeleccionado.iIdPerfil)) {
            handleOpenAlert("Este perfil de sistema no se puede eliminar", "info");
            return;
        }
        setModalOpenEliminarPerfil(true);
    };

    const handleClickAdministrarPerfil = () => {
        if (perfilSeleccionado.iIdPerfil === 0) {
            handleOpenAlert("Seleccione un perfil para administrar");
            return;
        }
        setModalOpenAdministrarPerfil(true);
        fnObtenerPermisosPerfil(perfilSeleccionado.iIdPerfil);
    };

    const handleClickRefrescarDatos = async () => {
        await fnObtenerElementosSistema();
        await fnObtenerPerfiles();
    };

    const handleClickRefrescarPermisos = () => {
        fnObtenerPermisosPerfil(perfilSeleccionado.iIdPerfil);
    };

    const handleClickSeleccionarModulos = () => {
        setModalOpenSeleccionarModulos(true);
        setModulosSeleccionados(
            listaSistemaModulos.filter((x) => listaPermisosPerfil.map((y) => y.iIdModulo).includes(x.iIdModulo))
        );
        setSeleccionarTodoModulos(listaSistemaModulos.length === listaPermisosPerfil.length);
    };

    const handleChangeModuloCheckbox = (modulo) => {
        const moduloIndex = modulosSeleccionados.indexOf(modulo);
        const nuevosModulosSeleccionados = [...modulosSeleccionados];

        if (moduloIndex === -1) {
            nuevosModulosSeleccionados.push(modulo);
        } else {
            nuevosModulosSeleccionados.splice(moduloIndex, 1);
        }

        setSeleccionarTodoModulos(nuevosModulosSeleccionados.length === listaSistemaModulos.length);

        setModulosSeleccionados(nuevosModulosSeleccionados);
    };

    const handleClickSeleccionarTodoModulos = (seleccionaTodo) => {
        setModulosSeleccionados(seleccionaTodo ? listaSistemaModulos : []);
        setSeleccionarTodoModulos(seleccionaTodo);
    };

    const handleClickSeleccionarSubmodulos = (e, lstSistemaSubmodulos, lstPermisosModulos) => {
        e.stopPropagation();
        setModalOpenSeleccionarSubmodulos(true);
        setListaSistemaSubmodulos(lstSistemaSubmodulos);

        setSubmodulosSeleccionados(
            lstSistemaSubmodulos.filter((x) => lstPermisosModulos.map((y) => y.iIdSubModulo).includes(x.iIdSubModulo))
        );
        setSeleccionarTodoSubmodulos(lstSistemaSubmodulos.length === lstPermisosModulos.length);
    };
    const handleChangeSubmoduloCheckbox = (submodulo) => {
        const moduloIndex = submodulosSeleccionados.indexOf(submodulo);
        const nuevosSubmodulosSeleccionados = [...submodulosSeleccionados];

        if (moduloIndex === -1) {
            nuevosSubmodulosSeleccionados.push(submodulo);
        } else {
            nuevosSubmodulosSeleccionados.splice(moduloIndex, 1);
        }

        setSeleccionarTodoSubmodulos(nuevosSubmodulosSeleccionados.length === listaSistemaSubmodulos.length);

        setSubmodulosSeleccionados(nuevosSubmodulosSeleccionados);
    };

    const handleClickSeleccionarTodoSubmodulos = (seleccionaTodo) => {
        setSubmodulosSeleccionados(seleccionaTodo ? listaSistemaSubmodulos : []);
        setSeleccionarTodoSubmodulos(seleccionaTodo);
    };

    const handleClickSeleccionarBotones = (e, lstSistemaBotones, lstPermisosBotones) => {
        e.stopPropagation();
        setModalOpenSeleccionarBotones(true);
        setListaSistemaBotones(lstSistemaBotones);

        setBotonesSeleccionados(
            lstSistemaBotones.filter((x) => lstPermisosBotones.map((y) => y.iIdBoton).includes(x.iIdBoton))
        );
        setSeleccionarTodoBotones(lstSistemaBotones.length === lstPermisosBotones.length);
    };

    const handleChangeBotonCheckbox = (boton) => {
        const botonIndex = botonesSeleccionados.indexOf(boton);
        const nuevosBotonesSeleccionados = [...botonesSeleccionados];

        if (botonIndex === -1) {
            nuevosBotonesSeleccionados.push(boton);
        } else {
            nuevosBotonesSeleccionados.splice(botonIndex, 1);
        }
        setSeleccionarTodoBotones(nuevosBotonesSeleccionados.length === listaSistemaBotones.length);

        setBotonesSeleccionados(nuevosBotonesSeleccionados);
    };

    const handleClickSeleccionarTodoBotones = (seleccionaTodo) => {
        setBotonesSeleccionados(seleccionaTodo ? listaSistemaBotones : []);
        setSeleccionarTodoBotones(seleccionaTodo);
    };

    const handleSubmitFormPerfil = (e) => {
        fnPrevent(e);

        const { txtNombrePerfil } = formPerfil;
        const form = {
            ...formPerfil,
            txtNombrePerfil: { ...txtNombrePerfil, error: txtNombrePerfil.value === "" },
        };
        setFormPerfil(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entPerfil = {
            iIdPerfil: perfilSeleccionado.iIdPerfil,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: txtNombrePerfil.value,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarPerfil(entPerfil);
    };

    const handleSubmitEliminarPerfil = (e) => {
        fnPrevent(e);
        const entPerfil = {
            iIdPerfil: perfilSeleccionado.iIdPerfil,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            sNombre: null,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarPerfil(entPerfil);
    };

    const handleSubmitModulos = () => {
        let listaPermisosParaGuardar = [];
        modulosSeleccionados.forEach((x) => {
            listaPermisosParaGuardar.push({
                iIdPerfil: perfilSeleccionado.iIdPerfil,
                iIdModulo: x.iIdModulo,
                iIdSubModulo: 0,
                iIdBoton: 0,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bActivo: true,
                bBaja: false,
            });
        });

        let modulosNoSeleccionados = listaSistemaModulos.filter(
            (x) => !modulosSeleccionados.map((y) => y.iIdModulo).includes(x.iIdModulo)
        );
        modulosNoSeleccionados.forEach((x) => {
            listaPermisosParaGuardar.push({
                iIdPerfil: perfilSeleccionado.iIdPerfil,
                iIdModulo: x.iIdModulo,
                iIdSubModulo: 0,
                iIdBoton: 0,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bActivo: false,
                bBaja: true,
            });
        });
        fnGuardarPermisosModulos(listaPermisosParaGuardar);
    };

    const handleSubmitSubmodulos = () => {
        let listaPermisosParaGuardar = [];
        submodulosSeleccionados.forEach((x) => {
            listaPermisosParaGuardar.push({
                iIdPerfil: perfilSeleccionado.iIdPerfil,
                iIdModulo: x.iIdModulo,
                iIdSubModulo: x.iIdSubModulo,
                iIdBoton: 0,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bActivo: true,
                bBaja: false,
            });
        });

        let submodulosNoSeleccionados = listaSistemaSubmodulos.filter(
            (x) => !submodulosSeleccionados.map((y) => y.iIdSubModulo).includes(x.iIdSubModulo)
        );
        submodulosNoSeleccionados.forEach((x) => {
            listaPermisosParaGuardar.push({
                iIdPerfil: perfilSeleccionado.iIdPerfil,
                iIdModulo: x.iIdModulo,
                iIdSubModulo: x.iIdSubModulo,
                iIdBoton: 0,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bActivo: false,
                bBaja: true,
            });
        });
        fnGuardarPermisosSubmodulos(listaPermisosParaGuardar);
    };

    const handleSubmitBotones = () => {
        let listaPermisosParaGuardar = [];
        botonesSeleccionados.forEach((x) => {
            listaPermisosParaGuardar.push({
                iIdPerfil: perfilSeleccionado.iIdPerfil,
                iIdModulo: x.iIdModulo,
                iIdSubModulo: x.iIdSubModulo,
                iIdBoton: x.iIdBoton,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bActivo: true,
                bBaja: false,
            });
        });

        let botonesNoSeleccionados = listaSistemaBotones.filter(
            (x) => !botonesSeleccionados.map((y) => y.iIdBoton).includes(x.iIdBoton)
        );

        botonesNoSeleccionados.forEach((x) => {
            listaPermisosParaGuardar.push({
                iIdPerfil: perfilSeleccionado.iIdPerfil,
                iIdModulo: x.iIdModulo,
                iIdSubModulo: x.iIdSubModulo,
                iIdBoton: x.iIdBoton,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bActivo: false,
                bBaja: true,
            });
        });
        fnGuardarPermisosBotones(listaPermisosParaGuardar);
    };

    const fnFillFormPerfil = (perfil) => {
        const model = getFormPerfil();
        const { txtIdPerfil, txtNombrePerfil } = model;
        setFormPerfil({
            ...model,
            txtIdPerfil: {
                ...txtIdPerfil,
                value: !perfil.iIdPerfil ? "" : perfil.iIdPerfil,
            },
            txtNombrePerfil: {
                ...txtNombrePerfil,
                value: !perfil.sNombre ? "" : perfil.sNombre,
            },
        });
    };

    const fnObtenerElementosSistema = async (iIdPerfil = null) => {
        const payload = {
            loader: "Consultando elementos del sistemas...",
            url: apiCguGetPermisoPerfil + "?iIdPerfil=" + iIdPerfil,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaSistemaModulos(response.Result);
        }
    };

    const fnObtenerPerfiles = async (iIdPerfil = null, bActivo = true, bBaja = false) => {
        const payload = {
            loader: "Consultando perfiles del sistema...",
            url: apiCguGetPerfiles + "?iIdPerfil=" + iIdPerfil + "&bActivo=" + bActivo + "&bBaja=" + bBaja,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaPerfiles(response.Result);
        }
    };

    const fnGuardarPerfil = async (entPerfil) => {
        const payload = {
            loader: "Guardando perfil...",
            url: apiCguCreatePerfil,
            body: entPerfil,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormPerfil(false);
            await fnObtenerPerfiles();
        }
        fnPreventBlur();
    };

    const fnEliminarPerfil = async (entPerfil) => {
        const payload = {
            loader: "Eliminando perfil...",
            url: apiCguCreatePerfil,
            body: entPerfil,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarPerfil(false);
            setPerfilSeleccionado(getModelPerfil());
            await fnObtenerPerfiles();
        }
        fnPreventBlur();
    };

    const fnObtenerPermisosPerfil = async (iIdPerfil = null) => {
        const payload = {
            loader: "Consultando permisos del perfil...",
            url: apiCguGetPermisoPerfil + "?iIdPerfil=" + iIdPerfil,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaPermisosPerfil(response.Result);
        }
        fnPreventBlur();
    };

    const fnGuardarPermisosModulos = async (lstPermisos) => {
        const payload = {
            loader: "Guardando permisos de módulos...",
            url: apiCguCreatePermiso,
            body: lstPermisos,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenSeleccionarModulos(false);
            await fnObtenerPermisosPerfil(perfilSeleccionado.iIdPerfil);
        }
        fnPreventBlur();
    };

    const fnGuardarPermisosSubmodulos = async (lstPermisos) => {
        const payload = {
            loader: "Guardando permisos de submódulos...",
            url: apiCguCreatePermiso,
            body: lstPermisos,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenSeleccionarSubmodulos(false);
            await fnObtenerPermisosPerfil(perfilSeleccionado.iIdPerfil);
        }
        fnPreventBlur();
    };

    const fnGuardarPermisosBotones = async (lstPermisos) => {
        const payload = {
            loader: "Guardando permisos de botones...",
            url: apiCguCreatePermiso,
            body: lstPermisos,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenSeleccionarBotones(false);
            await fnObtenerPermisosPerfil(perfilSeleccionado.iIdPerfil);
        }
        fnPreventBlur();
    };

    return (
        <PerfilContext.Provider
            value={{
                listaPerfiles,
                listaSistemaModulos,
                listaSistemaSubmodulos,
                listaSistemaBotones,
                listaPermisosPerfil,
                perfilSeleccionado,
                modalOpenFormPerfil,
                modalOpenEliminarPerfil,
                modalOpenAdministrarPerfil,
                modalOpenSeleccionarModulos,
                modalOpenSeleccionarSubmodulos,
                modalOpenSeleccionarBotones,
                modulosSeleccionados,
                submodulosSeleccionados,
                botonesSeleccionados,
                seleccionarTodoModulos,
                seleccionarTodoSubmodulos,
                seleccionarTodoBotones,
                formPerfil,
                handleChangePerfilSeleccionado,
                handleChangeFormText,
                handleChangeModuloCheckbox,
                handleChangeSubmoduloCheckbox,
                handleChangeBotonCheckbox,
                handleOpenFormPerfil,
                handleOpenEliminarPerfil,
                handleOpenAdministrarPerfil,
                handleOpenSeleccionarModulos,
                handleOpenSeleccionarSubmodulos,
                handleOpenSeleccionarBotones,
                handleClickNuevoPerfil,
                handleClickEditarPerfil,
                handleClickEliminarPerfil,
                handleClickAdministrarPerfil,
                handleClickRefrescarDatos,
                handleClickRefrescarPermisos,
                handleClickSeleccionarModulos,
                handleClickSeleccionarTodoModulos,
                handleClickSeleccionarSubmodulos,
                handleClickSeleccionarTodoSubmodulos,
                handleClickSeleccionarBotones,
                handleClickSeleccionarTodoBotones,
                handleSubmitFormPerfil,
                handleSubmitEliminarPerfil,
                handleSubmitModulos,
                handleSubmitSubmodulos,
                handleSubmitBotones,
            }}
        >
            {props.children}
        </PerfilContext.Provider>
    );
}

export function usePerfil() {
    return useContext(PerfilContext);
}
